import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import {CrimeMap} from "./map/CrimeMap";
import {FilterProvider} from './FilterContext'
import './index.css'
import axios from "axios";
import packageJson from '../package.json';


const resolveParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const schema = urlParams.get("schema");
    const agency = urlParams.get("agency");

    const cleanPath = window.location.pathname.replace(/\/$/, '') || '/';
    window.history.replaceState({}, document.title, cleanPath);

    if (schema && agency) {
        sessionStorage.setItem("schema", schema);
        sessionStorage.setItem("agency", agency);
        return { schema, agency };
    }

    return {
        schema: sessionStorage.getItem("schema"),
        agency: sessionStorage.getItem("agency"),
    };
};

const App = () => {
    const { schema, agency } = resolveParams();

    const [shapes, setShapes] = useState();
    const [error, setError] = useState();
    const [results, setResults] = useState();
    //
    const [calls, setCalls] = useState();
    //


    let initialStartDate = new Date();
    //initialStartDate.setMonth(initialStartDate.getMonth() - 6); // six months ago
    initialStartDate.setDate(initialStartDate.getDate() - 7); // 7 days ago

    const [context, setContext] = useState({
        schema: schema,
        agency: agency,
        filters: {
            "department": schema,
            "agency": agency,
            "start": initialStartDate.toISOString(),
            "showIncidents": "Y"
        },
        shapes: undefined
    });

    useEffect(() => {
        axios.get(packageJson.homepage+'/api/v1/validateSchema', {
            params: {
                schema: context.schema
            }
        }).then().catch(error => {
            setError(error);
        })
    }, [context.schema]);   //added dependency

    useEffect(() => {
        const config = {
            params: {
                agency: context.agency,
                schema: context.schema
            }
        };
        axios.get(packageJson.homepage+'/api/v1/getShapes', config)
            .then(res => setShapes(res.data))
            .catch(setError);
    }, [context.schema]);   //added dependency


    useEffect(() => {
        axios.post(packageJson.homepage + '/api/v1/queryIncidents', context.filters)
            .then(res => {
                //console.log('[queryIncidents] response:', res.data);
                setResults(res.data);
            })
            .catch(err => {
                console.error('[queryIncidents] error:', err.response ? err.response.data : err.message);
                setError(err);
            });
    }, [context.filters])


    useEffect(() => {
        axios.post(packageJson.homepage + '/api/v1/queryCalls', context.filters)
            .then(cls => {
                //console.log('[queryCalls] response:', cls.data);
                setCalls(cls.data);
            })
            .catch(err => {
                console.error('[queryCalls] error:', err.response ? err.response.data : err.message);
                setError(err);
            });
    }, [context.filters])

    const contextValue = {
        ...context,
        calls,
        shapes,
        results,
        error,
    }

    return (
        <FilterProvider value={[contextValue, setContext]}>
            <CrimeMap/>
        </FilterProvider>
    );
}

ReactDOM.hydrate(<App/>, document.getElementById('root'));